import { createContext, ReactNode } from 'react';
import { api } from '../server/api';
import {
  IPlayerPerformance,
  IPlayerQuizPerformances,
} from '../interfaces/IPlayerPerformance';

interface QuizContextProps {
  getPlayerPerformanceInAction: (
    actionId: string,
    playerId: string
  ) => Promise<IPlayerPerformance | undefined>;
  getPlayerPerformances: (
    playerId: string
  ) => Promise<IPlayerQuizPerformances | undefined>;
}

interface QuizContextProviderProps {
  children: ReactNode;
}

export const quizContext = createContext({} as QuizContextProps);
export function QuizContextProvider(props: QuizContextProviderProps) {
  const getPlayerPerformanceInAction = async (
    actionId: string,
    playerId: string
  ): Promise<IPlayerPerformance | undefined> => {
    try {
      const { data } = await api.get(
        `/actions/quiz/player-performances/${actionId}/${playerId}`
      );

      return data.body;
    } catch (error) {
      console.log('getPlayerPerformanceInAction error: ', error);
    }
  };

  const getPlayerPerformances = async (
    playerId: string
  ): Promise<IPlayerQuizPerformances | undefined> => {
    try {
      const { data } = await api.get(`/actions/quiz/${playerId}`);
      return data.body;
    } catch (error) {
      console.log('getPlayerPerformances error: ', error);
    }
  };

  return (
    <quizContext.Provider
      value={{
        getPlayerPerformanceInAction,
        getPlayerPerformances,
      }}
    >
      {props.children}
    </quizContext.Provider>
  );
}
